/* eslint-disable @angular-eslint/prefer-inject */
import { ReceiptLineDataService } from '../infrastructure/receipt-lines/receipt-line.data.service';
import {
    ReceiptLineCreate,
    ReceiptLineDto,
    ReceiptLineRead,
    ReceiptLineSearchParams,
} from '../entities/receipt-line.dto';
import { ReceiptLineStore } from '../infrastructure/receipt-lines/receipt-line.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { ReceiptLineMapper } from '../infrastructure/receipt-lines/receipt-line.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes, SafeAny } from '@pf/shared-common';
import { Observable, map } from 'rxjs';

@Injectable()
export class ReceiptLineFacade extends AbstractManageEntityFacade<
    ReceiptLineDto,
    ReceiptLineRead,
    ReceiptLineCreate,
    ReceiptLineSearchParams
> {
    nameField: keyof ReceiptLineDto = 'lineNumber';

    constructor(
        dataService: ReceiptLineDataService,
        store: ReceiptLineStore,
        mapper: ReceiptLineMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    protected override getParentId(dto: ReceiptLineDto): string | undefined {
        return dto.inventoryReceiptId;
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof ReceiptLineDto, string>> {
        return { lineNumber: searchText };
    }

    getByReceiptId$(receiptId: string): Observable<ReceiptLineDto[]> {
        return this.searchAll$(
            {
                pageIndex: 1,
                pageSize: 25,
                filters: { receiptId } as SafeAny,
            },
            false
        );
    }

    getByReceiptLineId$(id: string): Observable<ReceiptLineDto> {
        const receiptLineDataService = this
            .dataService as ReceiptLineDataService;
        return receiptLineDataService
            .getByReceiptLineId$(id)
            .pipe(map(receiptLine => this.mapper.toDTO(receiptLine)));
    }
}
